import { alertPageRoutes } from './constants'

const matchExact = (template, pathname) => {
  const pattern = template.replaceAll(/:[a-zA-Z0-9_]+/g, '[^/]+')

  return new RegExp(`^${pattern}$`).test(pathname)
}

const matchPrefix = (base, pathname) => pathname === base || pathname.startsWith(`${base}/`)

const appliesToChildren = (pageRoute, pathname) => {
  if (pageRoute.prefix) return pageRoute.paths.some(path => matchPrefix(path, pathname))

  return pageRoute.paths.some(path => matchExact(path, pathname))
}

const isAlertVisible = (alert, activePage) => {
  if (!alert.pages.length) return true

  return alert.pages.includes(activePage)
}

export const getActivePage = pathname => {
  const matched = alertPageRoutes.find(pageRoute => appliesToChildren(pageRoute, pathname))

  return matched ? matched.page : null
}

export const filterAlertsByPage = (alerts, pathname) => {
  if (!alerts?.length) return alerts

  const activePage = getActivePage(pathname)

  return alerts.filter(alert => isAlertVisible(alert, activePage))
}

export const getAlertLevelColors = theme => {
  return {
    warning: theme.colors.accent.hover,
    info: theme.colors.text.link.default,
  }
}
